// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"eaadd8cb","371":"6c8b8722","413":"44aa9fb7","421":"888a2d78","554":"801954bf","683":"762dbdf5","787":"ebe26e26","962":"88c8aa1a","970":"7454c8fa"}[chunkId] + ".chunk.js";
};